import { useQuery } from "@tanstack/react-query";
import {
  getCategories,
  getCategoryCourses,
  getCourseCategoryPics,
} from "@/api/query/categories";

export const useCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: getCategories,
  });
};

export const useCategoryCourses = (categoryId: number) => {
  return useQuery({
    queryKey: ["categoryCourses", categoryId],
    queryFn: () => getCategoryCourses(categoryId),
    enabled: !!categoryId,
  });
};

export const useCourseCategoryPics = (courseCategoryId: number) => {
  return useQuery({
    queryKey: ["courseCategoryPics", courseCategoryId],
    queryFn: () => getCourseCategoryPics(courseCategoryId),
    enabled: !!courseCategoryId,
  });
};
